import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

// material-ui
import withStyles from '@material-ui/core/styles/withStyles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import AppBar from '@material-ui/core/AppBar';

// components
import LocalizationsList from 'components/LocalizationsList';
import Loading from 'components/Loading';
import FormLocalization from 'components/FormLocalization';

// styles
import styles from './styles';

class WrapperLocalizationPage extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
    refresh: PropTypes.func,
    urlParams: PropTypes.object,
    history: PropTypes.object,
    loading: PropTypes.bool,
    localizations: PropTypes.array,
    languages: PropTypes.array,
    createLocalization: PropTypes.func,
    deleteLocalization: PropTypes.func,
    updateLocalization: PropTypes.func,
    getLocalizationRoles: PropTypes.func,
    createLocalizationRole: PropTypes.func,
    deleteLocalizationRole: PropTypes.func,
    roles: PropTypes.array,
  };

  constructor(...args) {
    super(...args);
    const { urlParams } = this.props;
    this.state = {
      index: urlParams.index ? Number(urlParams.index) : 0,
      selectedLocalization: undefined,
      formLocalizationOpen: false,
    };
  }

  getStepContent() {
    const { index } = this.state;
    const { localizations } = this.props;

    switch (index) {
      case 0:
        return (
          <LocalizationsList
            localizations={localizations}
            onSelect={selectedLocalization => this.setState({
              selectedLocalization,
              formLocalizationOpen: true,
            })}
          />
        );
      default:
    }

    return [];
  }

  render() {
    const {
      classes,
      history,
      loading,
      createLocalization,
      deleteLocalization,
      updateLocalization,
      languages,
      refresh,
      roles,
      getLocalizationRoles,
      createLocalizationRole,
      deleteLocalizationRole,
    } = this.props;

    const {
      index,
      selectedLocalization,
      formLocalizationOpen,
    } = this.state;

    return (
      <div className={`${classes.background} page`}>
        {
          loading
            ? (
              <Loading
                message={'Fetching all Localizations'}
              />
            )
            : (
              <div>
                <Helmet>
                  <title>Localizations</title>
                  <meta name="MyAccount" content="MyAccount page" />
                </Helmet>
                <AppBar position="static" className={classes.appBar}>
                  <Tabs
                    value={index}
                    onChange={(e, v) => {
                      this.setState({
                        index: v,
                      });
                      history.push(`?index=${v}`);
                    }}

                    indicatorColor="primary"
                    textColor="primary"
                    scrollable
                    scrollButtons="auto"
                    classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
                  >
                    <Tab
                      label="All"
                      classes={{
                        root: classes.tabRoot,
                        selected: classes.tabSelected,
                      }}
                    />
                  </Tabs>
                </AppBar>
                <div className="container withAppBarAndTabs">
                  {
                    this.getStepContent()
                  }
                </div>
              </div>
            )
        }
        <Button
          variant="fab"
          color="primary"
          aria-label="Add"
          className={classes.floatingActionButton}
          onClick={() => this.setState({ formLocalizationOpen: true })}
        >
          <AddIcon />
        </Button>
        <FormLocalization
          open={formLocalizationOpen}
          localization={selectedLocalization}
          close={() => {
            this.setState({
              formLocalizationOpen: false,
            });
            setTimeout(() => this.setState({
              selectedLocalization: undefined,
            }), 200);
          }
          }
          createLocalization={createLocalization}
          deleteLocalization={deleteLocalization}
          updateLocalization={updateLocalization}
          languages={languages}
          getLocalizationRoles={getLocalizationRoles}
          createLocalizationRole={createLocalizationRole}
          deleteLocalizationRole={deleteLocalizationRole}
          refresh={refresh}
        />
      </div>
    );
  }
}
export default withStyles(styles)(WrapperLocalizationPage);
